import React from "react";
import DropDown from "../Dropdown";
import { Input } from "antd";
import "./style.scss";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

const CategorySearch = (props) => {
  const {
    handleCategoryChange,
    selectedCategory,
    handleQueryChange,
    query,
    searchHandler,
  } = props;

  const { categories } = useSelector((state) => state.event);

  CategorySearch.propTypes = {
    handleCategoryChange: PropTypes.func,
    selectedCategory: PropTypes.string,
    handleQueryChange: PropTypes.func,
    query: PropTypes.string,
    searchHandler: PropTypes.func,
  };

  return (
    <div
      className="categorySearch flex"
      style={{ borderRadius: "14px", overflow: "hidden" }}
    >
      <div className="category">
        <div className="label">Category</div>
        <DropDown
          config={{
            placeholder: "Browse all",
            options: categories.map((item) => ({
              label: item.text,
              value: item.value,
            })),
            class: "categoryDropdown",
          }}
          handleChange={handleCategoryChange}
          selectedValue={selectedCategory}
          blackText={true}
        />
      </div>
      <div className="query">
        <div className="label">Query</div>
        <Input
          placeholder="Search for interest, location, date..."
          onChange={handleQueryChange}
          value={query}
        />
      </div>
      <div className="btnContainer">
        <div
          className="button"
          onClick={searchHandler}
          onKeyDown={searchHandler}
          style={{ borderRadius: 8, overflow: "hidden" }}
        >
          Search
        </div>
      </div>
    </div>
  );
};

export default CategorySearch;
